import { type TvChannel } from '@setplex/tria-api'
import type { TvChannelPayment } from '~/features/payment/interfaces'
import { getPaymentTvChannelMediaType } from '~/features/payment/lib'

export const formatEpgTvChannelPayment = (
  channel: TvChannel,
  query: URLSearchParams
): TvChannelPayment => {
  const categoryId = query.get('category') ?? 0
  const {
    id,
    priceSettings,
    free,
    purchaseInfo,
    logoUrl,
    name,
    channelNumber,
  } = channel

  return {
    ...channel,
    priceSettings: priceSettings ?? null,
    free: Boolean(free),
    purchaseInfo: purchaseInfo ?? null,
    logoUrl: logoUrl ?? '',
    name: String(name),
    id: Number(id),
    channelNumber: channelNumber ?? 0,
    categoryId: Number(categoryId),
    mediaType: priceSettings
      ? getPaymentTvChannelMediaType(priceSettings)
      : null,
  }
}
